import type { App } from '../app';
import type { AppState, Store } from '../state/store';
import { formatDuration, h } from './dom';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

export function renderCallBar(root: HTMLElement, app: App, store: Store): void {
  let keypadOpen = false;
  let timer: ReturnType<typeof setInterval> | null = null;

  const btn = (action: string, label: string, cls = '') => h('button', { type: 'button', 'data-action': action, class: cls }, label);

  const render = (s: AppState) => {
    root.replaceChildren();
    if (timer) clearInterval(timer);
    timer = null;
    const call = s.call;
    if (!call) {
      keypadOpen = false;
      return;
    }
    const who = h('div', { class: 'who' }, call.displayName ?? call.remote);
    const status = h('div', { class: 'status' });
    const bar = h('section', { class: 'card callbar', 'aria-live': 'polite' }, who, status);

    if (call.status === 'ringing-in') {
      status.textContent = `Eingehender Anruf von ${call.remote}`;
      const answer = btn('answer', 'Annehmen', 'ok');
      const reject = btn('reject', 'Ablehnen', 'danger');
      answer.addEventListener('click', () => app.answer());
      reject.addEventListener('click', () => app.reject());
      bar.append(h('div', { class: 'actions' }, answer, reject));
    } else {
      const update = () => {
        if (call.status === 'calling') status.textContent = 'Wird angerufen …';
        else if (call.status === 'held') status.textContent = 'Gehalten';
        else status.textContent = formatDuration(Math.floor((Date.now() - (call.answeredAt ?? Date.now())) / 1000));
      };
      update();
      if (call.status === 'established') timer = setInterval(update, 1000);

      const mute = btn('mute', call.muted ? 'Ton an' : 'Stumm', call.muted ? 'active' : '');
      const hold = btn('hold', call.held ? 'Fortsetzen' : 'Halten', call.held ? 'active' : '');
      const keypad = btn('keypad', 'Tastatur');
      const hangup = btn('hangup', 'Auflegen', 'danger');
      mute.addEventListener('click', () => app.toggleMute());
      hold.addEventListener('click', () => app.toggleHold());
      hangup.addEventListener('click', () => app.hangup());
      keypad.addEventListener('click', () => {
        keypadOpen = !keypadOpen;
        render(store.getState());
      });
      bar.append(h('div', { class: 'actions' }, mute, hold, keypad, hangup));
      if (keypadOpen) {
        const pad = h('div', { class: 'keypad' });
        for (const k of KEYS) {
          const key = h('button', { type: 'button', 'data-dtmf': k }, k);
          key.addEventListener('click', () => app.dtmf(k));
          pad.append(key);
        }
        bar.append(pad);
      }
    }
    root.append(bar);
  };

  store.subscribe(render);
  render(store.getState());
}
